import {
  SET_USER_DATA,
  DATA_USER_MANAGEMENT,
  LOADING_USER_MANAGEMENT,
} from '../constants/data_user';

const initialState = {
  rgdesc: null,
  mbdesc: null,
  brdesc: null,
  pn: null,
  name: null,
  kode_departemen: null,
  kode_region: null,
  kode_mainbranch: null,
  kode_branch: null,

  // data user management
  dataUserManagement: [],
  isLoadingDataUserManagement: true,
};

export default function reducer(state = initialState, action: any) {
  const { type, userDatas, dataUserManagement, isLoading } = action;
  switch (type) {
    case SET_USER_DATA:
      return {
        ...state,
        rgdesc: userDatas?.rgdesc,
        brdesc: userDatas?.brdesc,
        mbdesc: userDatas?.mbdesc,
        pn: userDatas?.pernr,
        name: userDatas?.sname,
        kode_departemen: userDatas?.role,
        kode_region: userDatas?.region,
        kode_mainbranch: userDatas?.mainbr,
        kode_branch: userDatas?.branch,
        jenis_kelamin: userDatas?.jenis_kelamin,
      };
    case DATA_USER_MANAGEMENT:
      return {
        ...state,
        dataUserManagement,
        isLoadingDataUserManagement: false,
      };

    case LOADING_USER_MANAGEMENT:
      return {
        ...state,
        isLoadingDataUserManagement: isLoading,
      };

    default:
      return state;
  }
}
